<template>
  <section class="new-collection container" v-if="product.related[type] && product.related[type].length > 0">
    <div>
      <header class="col-md-12 lg:text-left text-center">
        <h3 class="align-center lg:text-above-md leading-none tracking-lg text-average">
          {{ heading }}
        </h3>
      </header>
    </div>
    <div class="row center-xs">
      <product-listing
        columns="5"
        :products="product.related[type]"
        :category-id="categoryId"
        :show-add-to-cart-btn="false"
      />
    </div>
  </section>
</template>

<script>
import ProductListing from 'theme/components/core/ProductListing'
import { prepareRelatedQuery } from '@vue-storefront/core/modules/catalog/queries/related'
import i18n from '@vue-storefront/i18n'
import store from '@vue-storefront/core/store'

export default {
  name: 'Related',
  props: {
    categoryId: {
      type: [Number, String],
      required: true
    },
    type: {
      type: String,
      required: true
    },
    heading: {
      type: String,
      required: false,
      default: i18n.t('Similar products')
    }
  },
  components: {
    ProductListing
  },
  beforeMount() {
    this.$bus.$on('product-after-load', this.refreshList)
    if (store.state.config.usePriceTiers) {
      this.$bus.$on('user-after-loggedin', this.refreshList)
      this.$bus.$on('user-after-logout', this.refreshList)
    }
    this.refreshList()
  },
  beforeDestroy() {
    if (store.state.config.usePriceTiers) {
      this.$bus.$off('user-after-loggedin', this.refreshList)
      this.$bus.$off('user-after-logout', this.refreshList)
    }
  },
  destroyed() {
    this.$bus.$off('product-after-load', this.refreshList)
  },
  methods: {
    refreshList () {
      let sku = this.productLinks ? this.productLinks
        .filter(pl => pl.link_type === this.type)
        .map(pl => pl.linked_product_sku) : null
      let key = 'sku'
      if (sku === null || (sku.length === 0)) {
        sku = (((this.product || {}).current || {}).category || []).map(cat => cat.category_id)
        key = 'category_ids'
      }
      let relatedProductsQuery = prepareRelatedQuery(key, sku)
      this.$store.dispatch('product/list', {
        query: relatedProductsQuery,
        size: 10,
        prefetchGroupProducts: false,
        updateState: false
      }).then((response) => {
        if (response) {
          this.$store.dispatch('product/related', {
            key: this.type,
            items: response.items
          })
          this.$forceUpdate()
        }
      })
    }
  },
  computed: {
    product() {
      return this.$store.state.product
    },
    productLinks() {
      return this.product.current.product_links
    }
  }
}

</script>
